/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-test-item-attribute.reducer';

export const LabTestItemAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labTestItemAttributeEntity = useAppSelector(state => state.labTestItemAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labTestItemAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.detail.title">LabTestItemAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{labTestItemAttributeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.name">Name</Translate>
            </span>
          </dt>
          <dd>{labTestItemAttributeEntity.name}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.value">Value</Translate>
            </span>
          </dt>
          <dd>{labTestItemAttributeEntity.value}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{labTestItemAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labTestItemAttributeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{labTestItemAttributeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labTestItemAttributeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{labTestItemAttributeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.attributeType">Attribute Type</Translate>
          </dt>
          <dd>{labTestItemAttributeEntity.attributeType ? labTestItemAttributeEntity.attributeType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.attribute">Attribute</Translate>
          </dt>
          <dd>{labTestItemAttributeEntity.attribute ? labTestItemAttributeEntity.attribute.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.testItem">Test Item</Translate>
          </dt>
          <dd>{labTestItemAttributeEntity.testItem ? labTestItemAttributeEntity.testItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{labTestItemAttributeEntity.diagLab ? labTestItemAttributeEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.panel">Panel</Translate>
          </dt>
          <dd>{labTestItemAttributeEntity.panel ? labTestItemAttributeEntity.panel.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-test-item-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-test-item-attribute/${labTestItemAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabTestItemAttributeDetail;
